import { get } from "../../service/api";

const GetAccountRemainInfo = async (account) => {
  try {
    const response = await get(`/admin/getAccountRemain?account=${account}`);
    return response;
  } catch (error) {
    console.error("Error GetAccountRemainInfo:", error);
    throw error;
  }
};

export default GetAccountRemainInfo;
